import { useCallback, useState } from 'react';

const useListViewFloaterMenu = () => {
  const [openRowKey, setOpenRowKey] = useState<string | null>(null);

  const closeFloaterMenu = useCallback(() => {
    setOpenRowKey(null);
  }, []);

  const onDotsClick = useCallback((rowKey: string) => {
    setOpenRowKey((open) => (open === rowKey ? null : rowKey));
  }, []);

  /** Pipeline list view: row tap closes an open menu on another row, or selects the row key. */
  const onRowBodyClick = useCallback((rowKey: string) => {
    setOpenRowKey((open) => {
      if (open !== null && open !== rowKey) {
        return null;
      }
      return rowKey;
    });
  }, []);

  const isFloaterMenuOpen = useCallback(
    (rowKey: string) => openRowKey === rowKey,
    [openRowKey],
  );

  return {
    closeFloaterMenu,
    isFloaterMenuOpen,
    onDotsClick,
    onRowBodyClick,
    openRowKey,
  };
};

export { useListViewFloaterMenu };
